import '../node_modules/basscss/css/basscss.min.css';
import App from './App.svelte';
import './global.css';
const app = new App({
    target: document.body,
    props: {}
});
export default app;
